import type {
  ProfileState, SavePassword, SaveProfileInfo, 
} from 'types';
import { ProfileActionType } from './actionsTypes';

export const profileSetState = (payload: Partial<ProfileState>) => ({
  type: ProfileActionType.SetState,
  payload,
});

export const getProfileData = () => ({
  type: ProfileActionType.GET_DATA,
});

export const saveProfileInfo = (
  payload: SaveProfileInfo,
) => ({
  type: ProfileActionType.SAVE_PROFILE_INFO,
  payload,
});

export const savePassword = (
  payload: SavePassword,
) => ({
  type: ProfileActionType.SAVE_PASSWORD,
  payload,
});

export const claimCashback = () => ({
  type: ProfileActionType.CLAIM_CASHBACK,
});
